import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
const DIMENSIONS = [{
  label: 'Data foundations',
  value: 84,
  colour: '#D4AF37'
}, {
  label: 'Skills and literacy',
  value: 66,
  colour: '#8FA9CE'
}, {
  label: 'Governance',
  value: 41,
  colour: '#2E5E9E'
}, {
  label: 'Budget',
  value: 58,
  colour: '#E4E9F0'
}];
export function HeroArcs({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 320 320" aria-hidden="true" focusable="false" className={className} fill="none" data-id="element-322" data-mp="2e2v0lsuvzula">
      {[300, 258, 216, 174, 132, 90].map((radius, index) => <circle key={radius} cx="320" cy="0" r={radius / 2} stroke="#D4AF37" strokeOpacity={0.5 - index * 0.06} strokeWidth={index % 2 === 0 ? 10 : 4} data-id="element-323" data-mp="2nzzmdrktlo1k" data-mpi={index} />)}
    </svg>;
}
function Donut() {
  const reduced = useReducedMotion();
  const circumference = 2 * Math.PI * 42;
  const value = 72;
  return <svg viewBox="0 0 100 100" className="h-[104px] w-[104px]" role="img" aria-label="Readiness score, 72 out of 100" data-id="element-324" data-mp="2snng4qhs3x04">
      <circle cx="50" cy="50" r="42" fill="none" stroke="#E4E9F0" strokeWidth="10" data-id="element-325" data-mp="2np3s8kjmkb54" />
      <motion.circle cx="50" cy="50" r="42" fill="none" stroke="#D4AF37" strokeWidth="10" strokeLinecap="round" transform="rotate(-90 50 50)" strokeDasharray={circumference} initial={reduced ? false : {
      strokeDashoffset: circumference
    }} animate={{
      strokeDashoffset: circumference * (1 - value / 100)
    }} transition={{
      duration: reduced ? 0 : 1.1,
      ease: 'easeOut',
      delay: 0.2
    }} data-id="element-326" data-mp="2jlxmrf4c6nzp" />
      <text x="50" y="55" textAnchor="middle" className="font-display" fontSize="20" fill="#123C73" fontFamily="Playfair Display, serif" data-id="element-327" data-mp="1vx4pnfbzaa3i">
        72
      </text>
    </svg>;
}
export function PlatformMock() {
  const reduced = useReducedMotion();
  return <div className="w-full max-w-[620px] shadow-[0_24px_60px_rgba(3,15,33,0.45)]" data-id="element-328" data-mp="1catdb55t8iou">
      <div className="flex items-center gap-2 rounded-t-sm bg-[#6b7684] px-3 py-2" data-id="element-329" data-mp="1hap7kcopgvr7">
        {['#cfd6de', '#cfd6de', '#cfd6de'].map((colour, index) => <span key={index} className="h-2 w-2 rounded-full" style={{
        backgroundColor: colour
      }} data-id="element-330" data-mp="12eq1f7l5p5op" data-mpi={index} />)}
      </div>
      <div className="flex bg-champagne" data-id="element-331" data-mp="17dt6ut51tdx7">
        <div className="flex w-9 shrink-0 flex-col items-center gap-3.5 border-r border-line bg-white py-4" data-id="element-332" data-mp="1v2lwk7v2upjd">
          {Array.from({
          length: 8
        }).map((_, index) => <span key={index} className={`h-2 w-2 ${index === 1 ? 'bg-royal' : 'bg-[#c7d0dc]'}`} aria-hidden="true" data-id="element-333" data-mp="1lc10ar2vlx3m" data-mpi={index} />)}
        </div>
        <div className="min-w-0 flex-1 bg-white p-5 sm:p-6" data-id="element-334" data-mp="2e0ex53i8andl">
          <p className="font-display text-[19px] text-ink sm:text-[21px]" data-id="element-335" data-mp="2dz3vpac99rpn">AI Readiness Predictor</p>
          <div className="mt-3 space-y-2" aria-hidden="true" data-id="element-336" data-mp="2isg7gjvu640z">
            <span className="block h-2 w-full rounded-full bg-[#eef1f6]" data-id="element-337" data-mp="7bed0ezl75ux" />
            <span className="block h-2 w-3/5 rounded-full bg-[#eef1f6]" data-id="element-338" data-mp="2dctxu25v6jg" />
          </div>

          <div className="mt-6 grid gap-6 sm:grid-cols-2" data-id="element-339" data-mp="h1zjsppezgox">
            <div data-id="element-340" data-mp="h1g3fdfex0d0">
              <p className="text-[13px] text-muted" data-id="element-341" data-mp="h42731z6mvpy">Readiness band</p>
              <p className="mt-2 font-display text-[30px] leading-none text-ink" data-id="element-342" data-mp="c47hd1r58c6h">
                Ready<span className="text-muted" data-id="element-343" data-mp="3kjr5jmcyj4eo"> in parts</span>
              </p>
              <div className="mt-4 h-1.5 w-full overflow-hidden rounded-full bg-[#eef1f6]" data-id="element-344" data-mp="3fk4spe11jq6e">
                <motion.span className="block h-full rounded-full bg-royal" initial={reduced ? false : {
                width: 0
              }} animate={{
                width: '72%'
              }} transition={{
                duration: reduced ? 0 : 0.9,
                ease: 'easeOut',
                delay: 0.15
              }} data-id="element-345" data-mp="3tj4fsh8wnx0g" />
              </div>
              <div className="mt-1.5 flex justify-between text-[10px] text-muted" data-id="element-346" data-mp="14qijwhyb8n5x">
                {[0, 25, 50, 75, 100].map(tick => <span key={tick} data-id="element-347" data-mp="203tavxofw35c">{tick}</span>)}
              </div>
              <p className="mt-3 text-[11px] text-muted" data-id="element-348" data-mp="243loiosowzhk">Scored across 412 assessed organisations</p>
            </div>

            <div className="flex items-center gap-4" data-id="element-349" data-mp="294risr200ut7">
              <Donut data-id="element-350" data-mp="2e2axfs2lz9lo" />
              <ul className="space-y-1.5" data-id="element-351" data-mp="2e2t47imwd67u">
                {DIMENSIONS.map(dimension => <li key={dimension.label} className="flex items-center gap-2 text-[11px] text-body" data-id="element-352" data-mp="2j0cfqas7n4w3">
                    <span aria-hidden="true" className="h-2.5 w-2.5 shrink-0" style={{
                  backgroundColor: dimension.colour
                }} data-id="element-353" data-mp="2n0d7ex4blcl3" />
                    {dimension.label}: {dimension.value}%
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
}